import echarts from "echarts";
import {config} from "@/views/home/chartJs/chartCommon";

export default function drawLine(data, unit) {
  let {
    fontColor,
    fontSize,
    barColor,
    barColorOpacity,
    barLineBasicColor,
    tooltip,
    legend,
    xAxis,
    yAxis,
    grid
  } = config;
  let dimensions = [];
  // let copyData = JSON.parse(JSON.stringify(data))
  // setInterval(()=>{
  //   let promise = new Promise((resolve,reject)=>{
  //     data.splice(1)
  //     dimensions = []
  //     resolve()
  //   })
  //   promise.then(()=>{
  //     // for (let i in data[0]) {
  //     //   setTimeout(()=>{
  //     //   dimensions.push(i);
  //     // },1000)
  //     // }
  //     for (let i = 1; i < copyData.length; i++) {
  //       setTimeout(()=>{
  //       data.push(copyData[i])
  //     },i*10)
  //     }
  //   })
  // },5000)
  for (let i in data[0]) {
    dimensions.push(i);
  }

  function seriesItemStyle(c1, c2) {
    //柱子样式
    return {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: c1,
        },
        {
          offset: 1,
          color: c2,
        },
      ]),
      barBorderRadius: [5, 5, 0, 0],
    };
  }

  let option = {
    // backgroundColor: '#11183c',
    dataset: {
      dimensions,
      source: data,
    },
    grid,
    tooltip: { //提示框组件
      trigger: 'axis',
      // formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}',
      axisPointer: {
        type: 'shadow',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      textStyle: {
        color: '#fff',
        fontStyle: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
      }
    },
    legend: {
      ...legend,
      left: '15%',
      top: '6%',
    },
    xAxis: [
      {
        ...xAxis[0],
        axisLabel:{
          ...xAxis[0].axisLabel,
          interval: 0
        }
      }
    ],
    yAxis: [
      {
        ...yAxis[0],
        name: '单位：' + unit,
      },
    ],
    series: [
      {
        name: '私营',
        type: 'line',
        smooth: .6,
        symbolSize: 0,
        itemStyle: {
          normal: {
            color: '#00d4c7',
            lineStyle: {
              color: '#00c9ff',
              width: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(32,184,237,0.02)'
              }, {
                offset: .8,
                color: 'rgba(0,120,255, .4)'
              }]),
            }
          },
        },
      },
      {
        name: '个体',
        type: 'line',
        symbolSize: 0,
        smooth: .6,
        itemStyle: {
          normal: {
            color: '#0092f6',
            lineStyle: {
              color: '#0078ff',
              // color: seriesItemStyle('#4bb1ff', '#0e69bf'),
              width: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(32,184,237,0.02)'
              }, {
                offset: .8,
                color: 'rgba(0,120,255, .4)'
              }]),
            }
          },
        },
      },
    ],
  };
  return option;
}
